/* Bloques extra de la página de producto: fecha estimada de envío y aviso de stock por variante */
(function () {
  'use strict';

  var DIAS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
  var MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

  function sumarDias(base, dias, saltarFinde) {
    var d = new Date(base.getTime());
    if (!saltarFinde) {
      d.setDate(d.getDate() + dias);
      return d;
    }
    var sumados = 0;
    while (sumados < dias) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) sumados++;
    }
    return d;
  }

  function formato(d) {
    return DIAS[d.getDay()] + ' ' + d.getDate() + ' ' + MESES[d.getMonth()];
  }

  function pintarFechas(root) {
    var nodos = (root || document).querySelectorAll('[data-fecha-envio]');
    for (var i = 0; i < nodos.length; i++) {
      var el = nodos[i];
      var min = parseInt(el.getAttribute('data-dias-min'), 10) || 0;
      var max = parseInt(el.getAttribute('data-dias-max'), 10) || 0;
      var finde = el.getAttribute('data-saltar-finde') === 'true';
      var hoy = new Date();
      var texto = formato(sumarDias(hoy, min, finde));
      if (max > min) texto += ' - ' + formato(sumarDias(hoy, max, finde));
      el.textContent = texto;
    }
  }

  function initUrgencia(wrap) {
    var lineas = wrap.querySelectorAll('[data-urgencia-variante]');
    if (!lineas.length) return;
    var scope = wrap.closest('.shopify-section') || document;

    function mostrar(id) {
      if (!id) return;
      id = String(id);
      var existe = false;
      for (var i = 0; i < lineas.length; i++) {
        if (lineas[i].getAttribute('data-urgencia-variante') === id) existe = true;
      }
      if (!existe) {
        for (var k = 0; k < lineas.length; k++) lineas[k].setAttribute('hidden', '');
        return;
      }
      for (var j = 0; j < lineas.length; j++) {
        if (lineas[j].getAttribute('data-urgencia-variante') === id) lineas[j].removeAttribute('hidden');
        else lineas[j].setAttribute('hidden', '');
      }
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (evento) {
        var v = evento && evento.data && evento.data.variant;
        if (v) mostrar(v.id);
        else for (var k = 0; k < lineas.length; k++) lineas[k].setAttribute('hidden', '');
      });
    } else {
      document.addEventListener('change', function () {
        setTimeout(function () {
          var input = scope.querySelector('input[name="id"]');
          if (input) mostrar(input.value);
        }, 300);
      });
    }
  }

  function iniciar(root) {
    pintarFechas(root);
    var wraps = (root || document).querySelectorAll('[data-urgencia-stock]');
    for (var i = 0; i < wraps.length; i++) initUrgencia(wraps[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
  } else {
    iniciar(document);
  }

  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
